import { Box, Typography, Grid, Stack } from '@mui/material';
import { FadeIn } from './FadeIn';

export interface StepItem {
    title: string;
    description: string;
}

interface StepsGridProps {
    steps: StepItem[];
    columns?: number;
}

export function StepsGrid({
    steps,
    columns = 3
}: StepsGridProps) {
    return (
        <Box sx={{ mb: 6 }}>
            <Grid container spacing={4} justifyContent="center" sx={{ mb: 6 }}>
                {steps.map((step, index) => (
                    <Grid item xs={12} md={12 / columns} key={index}>
                        <FadeIn delay={index * 100} direction="up">
                            <Stack alignItems="center" textAlign="center" spacing={2}>
                                {/* Numbered Circle */}
                                <Box
                                    sx={{
                                        width: 48,
                                        height: 48,
                                        borderRadius: '50%',
                                        bgcolor: 'white',
                                        color: 'primary.main',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontWeight: 700,
                                        fontSize: '1.25rem',
                                        mb: 1,
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
                                        border: '1px solid',
                                        borderColor: 'divider'
                                    }}
                                >
                                    {index + 1}
                                </Box>

                                <Typography variant="h6" component="h3" fontWeight={700}>
                                    {step.title}
                                </Typography>

                                <Typography variant="body1" color="text.secondary" sx={{ minHeight: { md: 72 } }}>
                                    {step.description}
                                </Typography>
                            </Stack>
                        </FadeIn>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}
